import { createFileRoute, useParams } from '@tanstack/react-router';
import { SectionFormWrapper, AttributeRenderer, RenderContentProps } from '../../../../-shared';
import { useGetHandlingCertificationDetail, useUpdateHandlingCertificationDetail } from '../../../../-shared/-query';
export const Route = createFileRoute('/_staff/certification/handling-certification/$id/_layout/_index/')({
  component: HandlingCertificationDetail
});
function HandlingCertificationDetail() {
  const {
    id
  } = useParams({
    from: '/_staff/certification/handling-certification/$id/_layout/_index/'
  });
  return <SectionFormWrapper useGetDetailQuery={useGetHandlingCertificationDetail(id)} useSaveMutation={useUpdateHandlingCertificationDetail(id)} renderContent={({
    section
  }: RenderContentProps) => <AttributeRenderer attributes={section.attributes} sectionKey={String(section.sectionKey)} />} />;
}